import { render, staticRenderFns } from "./settingSftp.vue?vue&type=template&id=da29972c&scoped=true&"
import script from "./settingSftp.vue?vue&type=script&lang=js&"
export * from "./settingSftp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da29972c",
  null
  
)

export default component.exports